export enum AsyncOperations {
  getUserProfile = 'getUserProfile',
  resetPassword = 'resetPassword',
  updateDetails = 'updateDetails',
  getMenu = 'getMenu',
  switchTenant = 'switchTenant',
  login = 'login'
}
